// Date.toISOString()と同じフォーマット（ISO 8601拡張形式）でタイムゾーン情報付きの文字列を出力する関数
function toISOStringWithTimezone(date) {
  // 古典的なslice(-2)の代わりに、モダンなpadStartを使用
  const pad = (num) => String(num).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hour = pad(date.getHours());
  const min = pad(date.getMinutes());
  const sec = pad(date.getSeconds());
  
  const tz = -date.getTimezoneOffset();
  const sign = tz >= 0 ? "+" : "-";
  
  // タイムゾーンの計算（分を時間と分に分割）
  const tzHour = pad(Math.floor(Math.abs(tz) / 60));
  const tzMin = pad(Math.abs(tz) % 60);

  return `${year}-${month}-${day}T${hour}:${min}:${sec}${sign}${tzHour}:${tzMin}`;
}

export default toISOStringWithTimezone;

export function FormatDateString(dateStr) {
  // 2023-04-13T03:01:32.000000Zの文字列をYY/MM/DDの文字列に変換
  const date = new Date(dateStr);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  
  const formattedDate = `${month}/${day} ${hours}:${minutes}`;
  return formattedDate;
}

export function FindLatestDate(dateStrList) {
  if (!dateStrList || dateStrList.length === 0) return "";

  // applyによるコールスタックオーバーフローを防ぐため、getTime()で数値の配列に変換してから展開
  const maxTime = Math.max(...dateStrList.map((dateStr) => new Date(dateStr).getTime()));
  const date = new Date(maxTime);
  
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  
  const formattedDate = `${month}/${day} ${hours}:${minutes}`;
  return formattedDate;
}
